import "./polyfills"
import "./elements"
import "./script_warning"

export * from "./core"
import { start } from "./core"
start()
